import { createFileRoute } from "@tanstack/react-router";
import { EntityFormPage } from "@/components/entity-page/EntityFormPage";
import CreateAgentTypeForm from "@/components/CreateAgentTypeForm";

export const Route = createFileRoute("/dashboard/settings/agentTypes/new")({
  component: CreateAgentTypePage,
});

function CreateAgentTypePage() {
  return <CreateAgentTypePageComponent />;
}

// Exported for testing
export function CreateAgentTypePageComponent() {
  return (
    <EntityFormPage
      title="Create Agent Type"
      description="Add a new agent type to the catalog."
      backHref="/dashboard/settings/agentTypes"
    >
      <CreateAgentTypeForm />
    </EntityFormPage>
  );
}
